"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _UncontrolledTooltip = require("./UncontrolledTooltip");
Object.keys(_UncontrolledTooltip).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UncontrolledTooltip[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UncontrolledTooltip[key];
    }
  });
});